import React from 'react';
import { useTheme } from '@fluentui/react';
import { Info16Regular as InfoIcon } from '@fluentui/react-icons';
import { IAppTheme } from 'common/theme/AppTheme';

import { IButtonImplProps } from '../BaseButton.types';
import { IconButton } from '../IconButton';

import { getStyles } from './InfoIconButton.styles';

const InfoIconButton = (props: IButtonImplProps) => {
  const theme = useTheme() as IAppTheme;

  const { className, styles, ...otherProps } = props;
  const customStyles = getStyles(theme, styles);
  return (
    <IconButton className={className} styles={customStyles} {...otherProps}>
      <InfoIcon primaryFill={theme.palette.themeDark} />
    </IconButton>
  );
};

export default InfoIconButton;
